/* eslint-disable no-param-reassign */
import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import advertisementsSlice from '@/components/advertisements/redux/slice';
import settingsOverviewSlice from '@/components/Map/WelcomeMessageAccordion/redux/slice';

import ambientModeSlice from './ambient/slice';
import videoPlayerConfigSlice from './videoPlayerConfig/slice';
import visitedLinksSlice from './visitedLinks/slice';

const videoPlayerConfigPersistConfig = {
  version: 1,
  key: videoPlayerConfigSlice.name,
  storage,
  // We usually need to mute the video to auto play after the page is reloaded,
  // so we always set the muted state to true when the page is reloaded.
  blacklist: ['muted'],
};

const settingsSlice = combineReducers({
  [settingsOverviewSlice.name]: settingsOverviewSlice.reducer,
  [advertisementsSlice.name]: advertisementsSlice.reducer,
  [videoPlayerConfigSlice.name]: persistReducer(videoPlayerConfigPersistConfig, videoPlayerConfigSlice.reducer),
  [ambientModeSlice.name]: ambientModeSlice.reducer,
  [visitedLinksSlice.name]: visitedLinksSlice.reducer,
});

export type SettingsState = ReturnType<typeof settingsSlice>;

export default settingsSlice;
